import { render, staticRenderFns } from "./DashboardRequests.vue?vue&type=template&id=5e88c9dc&scoped=true"
import script from "./DashboardRequests.vue?vue&type=script&lang=js"
export * from "./DashboardRequests.vue?vue&type=script&lang=js"
import style0 from "./DashboardRequests.vue?vue&type=style&index=0&id=5e88c9dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e88c9dc",
  null
  
)

export default component.exports